import TopHeader from "./topheader.js";

export default function Contact() {
    return (
        <>
            <TopHeader MenuLevel="Contact" />
        </>
    )
}